import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Base_Url } from '../config';
import { useSelector } from 'react-redux';

const EditContactInfo = () => {
  const userDataRedux = useSelector((state) => state.user.userData);
  const [contactInfo, setContactInfo] = useState({
    title: '',
    phone: '',
    email: '',
    location: '',
    updated_by: ''
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    fetchContactInfo();
  }, [id]);

  const fetchContactInfo = async () => {
    try {
      const response = await axios.get(`${Base_Url}/contact/${id}`);
      setContactInfo({
        ...response.data,
        updated_by: userDataRedux?.userid || userDataRedux?.user_id || ''
      });
      setLoading(false);
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setError('Contact information not found');
      } else if (err.response && err.response.status === 500) {
        setError('Server error. Please try again later');
      } else if (err.request) {
        setError('Network error. Please check your connection');
      } else {
        setError('Failed to fetch contact information');
      }
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setContactInfo(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!contactInfo.title || !contactInfo.phone || !contactInfo.email || !contactInfo.location) {
      setError('All fields are required');
      return;
    }

    try {
      const userId = userDataRedux?.userid || userDataRedux?.user_id || 'unknown';
      
      const dataToSend = {
        ...contactInfo,
        updated_by: userId
      };
      
      await axios.put(`${Base_Url}/contact/${id}`, dataToSend);
      navigate('/contact');
    } catch (err) {
      if (err.response && err.response.status === 400) {
        setError('Invalid data. Please check your inputs');
      } else if (err.response && err.response.status === 404) {
        setError('Contact information not found');
      } else if (err.response && err.response.status === 500) {
        setError('Server error. Please try again later');
      } else if (err.request) {
        setError('Network error. Please check your connection');
      } else {
        setError('Failed to update contact information');
      }
    }
  };

  if (loading) return (
    <div className="container mt-5">
      <div className="d-flex justify-content-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  );

  return (
    <div className="container mt-5">
      <h2 className="mb-4">Edit Contact Information</h2>
      
      {error && (
        <div className="alert alert-danger alert-dismissible fade show" role="alert">
          {error}
          <button 
            type="button" 
            className="btn-close" 
            onClick={() => setError('')}
          ></button>
        </div>
      )}
      
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="title" className="form-label">Title:</label>
          <input
            type="text"
            className="form-control"
            id="title"
            name="title"
            value={contactInfo.title}
            onChange={handleChange}
            required
          />
        </div>
        
        <div className="mb-3">
          <label htmlFor="phone" className="form-label">Phone:</label>
          <input
            type="tel"
            className="form-control"
            id="phone"
            name="phone"
            value={contactInfo.phone}
            onChange={handleChange}
            required
          />
        </div>
        
        <div className="mb-3">
          <label htmlFor="location" className="form-label">Location:</label>
          <input
            type="text"
            className="form-control"
            id="location"
            name="location"
            value={contactInfo.location}
            onChange={handleChange}
            required
          />
        </div>
        
        <div className="mb-3">
          <label htmlFor="email" className="form-label">Email:</label>
          <input
            type="email"
            className="form-control"
            id="email"
            name="email"
            value={contactInfo.email}
            onChange={handleChange}
            required
          />
        </div>
        
        <div className="d-flex gap-2">
          <button type="submit" className="btn btn-primary">
            Update Contact
          </button>
          <button 
            type="button" 
            className="btn btn-secondary"
            onClick={() => navigate('/contact')}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditContactInfo;